import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { FiImageSize } from '../../../../shared/types';
import { IMediaBankFileReference } from '../../../../shared/media-bank';
import { AppTextService } from '@fi-shared/app-text';

export enum SiteDesignSettingLoginImagesType {
    Logo,
    Background,
}

export interface ISiteDesignSettingLoginImagesData {
    type: SiteDesignSettingLoginImagesType;
    label: string;
    imageSize: FiImageSize;
    imageSizeStr: string;
}

@Component({
    selector: 'fi-brand-editor-images-card',
    templateUrl: './fi-brand-editor-images-card.component.html',
    styleUrls: ['./fi-brand-editor-images-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-brand-editor-images-card' },
    standalone: false,
})
export class FiBrandEditorImagesCardComponent implements OnInit {
    @Input() isDefaultBrand: boolean;

    @Input() logoReference: IMediaBankFileReference;
    @Output() logoReferenceChange = new EventEmitter<IMediaBankFileReference>();

    @Input() landscapeReference: IMediaBankFileReference;
    @Output() landscapeReferenceChange = new EventEmitter<IMediaBankFileReference>();

    private readonly loginSettingsImagesData: ISiteDesignSettingLoginImagesData[] = [
        {
            type: SiteDesignSettingLoginImagesType.Logo,
            label: 'site_design.logo_image',
            imageSize: FiImageSize.Logo,
            imageSizeStr: '150 x 150',
        },
        {
            type: SiteDesignSettingLoginImagesType.Background,
            label: 'site_design.background_image',
            imageSize: FiImageSize.Background,
            imageSizeStr: '1920 x 1080',
        },
    ];

    availableBrandImageSettings: ISiteDesignSettingLoginImagesData[] = [];

    constructor(private appTextService: AppTextService) {}

    ngOnInit() {
        this.setAvailableBrandImageSettings();
    }

    private setAvailableBrandImageSettings() {
        if (this.isDefaultBrand) {
            this.availableBrandImageSettings = this.loginSettingsImagesData;
        } else {
            this.availableBrandImageSettings = this.loginSettingsImagesData.filter((data) => {
                return data.type === SiteDesignSettingLoginImagesType.Logo;
            });
        }
    }

    getCardTitle(): string {
        return this.appTextService.get(
            this.isDefaultBrand ? 'appearance.customer_settings_images' : 'site_design.brand_logo',
        );
    }

    getCardSubtitle(): string {
        return this.appTextService.get(
            this.isDefaultBrand ? 'site_design.login_image_description' : 'site_design.brand_logo_description',
        );
    }

    onLandscapeReferenceChange($event: IMediaBankFileReference) {
        this.landscapeReferenceChange.emit($event);
    }

    onLogoReferenceChange($event: IMediaBankFileReference) {
        this.logoReferenceChange.emit($event);
    }
}
